export default __webpack_public_path__ + "static/media/news1.ae39f2c0.jpg";